
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/zamowienie-zlozone",
      function () {
        return require("private-next-pages/zamowienie-zlozone.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/zamowienie-zlozone"])
      });
    }
  